/* eslint-disable @typescript-eslint/no-unused-vars */
import Image from "ui-components/Image";
import { useNavigate, useLocation, Link } from "react-router-dom";
import Tabs from "ui-components/Tabs";
import { useMediaQuery } from "utils/useMediaQuery";
import { useScreenDetector } from "utils/useScreenDetector";
import { isTestnet } from "utils/configs";
import { NavLink } from "react-router-dom";
import classNames from "classnames";

const Sidebar = () => {
    const { isMobile } = useScreenDetector();
    const links: {
        index: any;
        key: string;
        value: any;
        icon: string;
        onClick: () => void;
    }[] = isTestnet
        ? [
              {
                  index: 0,
                  key: "/bridge",
                  value: "Bridge",
                  icon: "bridge",
                  onClick: () => {},
              },
              { index: 1, key: "/transaction-history", value: "My history", icon: "history", onClick: () => {} },
              { index: 2, key: "/network-stats", value: "Network stats", icon: "history", onClick: () => {} },
          ]
        : [
              {
                  index: 0,
                  key: "/bridge",
                  value: "Bridge",
                  icon: "bridge",
                  onClick: () => {},
              },
              {
                  index: 1,
                  key: "/staking",
                  value: "Staking",
                  icon: "staking",
                  onClick: () => {},
              },
              {
                  index: 2,
                  key: "/liquidity",
                  value: (
                      <span>
                          Liquidity
                          {/* <span className="bg-core px-1 py-[2px]  rounded-lg">Boosted TST</span> */}
                      </span>
                  ),
                  icon: "liquidity",
                  onClick: () => {},
              },

              // {
              //     index: 3,
              //     key: "/referral-stats",
              //     value: <span>Referral</span>,
              //
              // },
              {
                  index: 3,
                  key: "/transaction-history",
                  value: "History",
                  icon: "history",
                  onClick: () => {},
              },
              { index: 4, key: "/network-stats", value: "Network", icon: "stats", onClick: () => {} },
          ];

    const navigate = useNavigate();
    const location = useLocation();
    const pathname = location?.pathname;

    const activeHomeIndex = (pathname === "/" ? 0 : links.find((i) => i.key.includes(pathname))?.index) || 0;

    const handleChange = (index: number) => {
        navigate(`${links[index].key}`);
    };
    const matches = useMediaQuery("(min-width: 768px)");

    const Link = ({ children, href, className = "", target = "", disabled = false, activeClassName }: any) => {
        return (
            <NavLink
                to={href}
                replace={false}
                className={({ isActive }) =>
                    isActive
                        ? `${className} ${disabled ? "disabled" : ""} ${activeClassName}`
                        : `${className} ${disabled ? "disabled" : ""} `
                }
                target={target}
                rel="noopener noreferrer"
            >
                {children}
            </NavLink>
        );
    };
    return isMobile ? (
        // <div className="flex flex-col  md:max-w-[1000px] w-full  relative ">
        //     <Tabs
        //         type={matches ? "outline" : "inline"}
        //         bg={matches ? "bg-ground-dark" : "bg-ground"}
        //         selectedIndex={activeHomeIndex}
        //         items={links}
        //         showNav={false}
        //         onChange={handleChange}
        //     />
        //     {/* <div className="w-full flex justify-end">
        //         <a
        //             href={"https://teleportdao.xyz/"}
        //             target={"_blank"}
        //             rel="noopener noreferrer"
        //             className="  h-[40px] w-fit pt-2 px-4 md:px-2 text-primary text-base flex items-center justify-end mb-5 md:mb-1 "
        //         >
        //             Powered by
        //             <Image
        //                 className=" mx-1"
        //                 title="Teleport-DAO"
        //                 src={"/images/teleport.png"}
        //                 width="24"
        //                 height="24"
        //                 alt="Teleport-DAO"
        //             />
        //             TeleportDAO
        //         </a>
        //     </div> */}
        // </div>
        <div className=" flex  fixed z-[2]  bottom-0  left-0 right-0  bg-[#0F0F0F]  px-4  ">
            <div className="flex flex-row justify-between items-end w-full mx-auto">
                {links.map((item, index) => {
                    return (
                        <Link
                            className={classNames(
                                "flex flex-col items-center px-2  gap-2 pb-2 transition-colors relative",
                            )}
                            key={index}
                            href={item.key}
                            onClick={item.onClick}
                        >
                            {activeHomeIndex === item.index ? (
                                <div className="trapezoid"></div>
                            ) : (
                                <div className="h-[4.5px] w-full "></div>
                            )}
                            <div
                                className={classNames(
                                    "flex flex-col  items-center  transition-colors",
                                    activeHomeIndex === item.index
                                        ? `text-core px-1 pt-2 bg-gradient-to-b from-green-fade-from to-green-fade-to`
                                        : `text-gray-lighter`,
                                )}
                            >
                                <Image
                                    src={`/images/menu/${activeHomeIndex === item.index ? "active/" : ""}${item.icon}.svg`}
                                    width="20"
                                    className={classNames(activeHomeIndex === item.index ? `fill-core` : ``)}
                                    height="20"
                                    alt={item.icon}
                                />
                                <span className={classNames(`text-xs py-2 `)}>{item.value}</span>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </div>
    ) : undefined;
};
export default Sidebar;
